import * as React from "react";
import {BaseDict} from "./dict";
import * as CMP from "./components";

export class HamburgerNavigationCasinoBlock extends React.Component < {
    dict : BaseDict,
    cms : any
}, {} > {
    dict: BaseDict;
    cmsChildren: any = [];

    constructor(props) {
        super(props);

        // setup dictionary
        this.dict = this.props.dict;

        // setup cms
        this.cmsChildren = this.props.cms.Children;
    }

    renderCasinoItems() {
        return this
            .cmsChildren
            .map(this.renderCasinoItem);
    }

    renderCasinoItem(casinoItem, index) {
        return ((casinoItem.Title || (casinoItem.Link && casinoItem.LinkText) || casinoItem.Image || casinoItem.FreeHtml) && <CMP.CasinoItem
            key={index}
            title={casinoItem.Title}
            link={casinoItem.Link}
            linkText={casinoItem.LinkText}
            image={casinoItem.Image}
            freeHtml={casinoItem.FreeHtml}/>);
    }

    render() {
        return (
            <div className="rj-hamburger-casino-block">
                {this.renderCasinoItems()}
            </div>
        )
    }
}